<h2 mat-dialog-title>
  <mat-icon>code</mat-icon>
  {{ data.title }}
</h2>

<mat-dialog-content>
  <div class="json-viewer">
    <pre>{{ data.json }}</pre>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="copyToClipboard()">
    <mat-icon>content_copy</mat-icon>
    Copy to Clipboard
  </button>
  <button mat-button (click)="close()" cdkFocusInitial>Close</button>
</mat-dialog-actions>
